import { Box, Typography, Breadcrumbs, Link } from "@mui/material"
import { useLocation } from "react-router-dom"
import { Home, NavigateNext } from "@mui/icons-material"

const EnhancedHeader = ({ title, subtitle, actions, breadcrumbs }) => {
    const location = useLocation()

    const defaultBreadcrumbs = [
        { label: "Dashboard", href: "/", icon: <Home sx={{ fontSize: 16 }} /> },
        { label: title, current: true },
    ]

    const crumbs = breadcrumbs || defaultBreadcrumbs

    return (
        <Box sx={{ mb: 4 }}>
            {/* Breadcrumbs */}
            <Breadcrumbs separator={<NavigateNext fontSize="small" />} sx={{ mb: 2 }}>
                {crumbs.map((crumb, index) =>
                    crumb.current ? (
                        <Typography key={index} color="text.primary" sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            {crumb.icon}
                            {crumb.label}
                        </Typography>
                    ) : (
                        <Link
                            key={index}
                            underline="hover"
                            color="inherit"
                            href={crumb.href}
                            sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                        >
                            {crumb.icon}
                            {crumb.label}
                        </Link>
                    ),
                )}
            </Breadcrumbs>

            {/* Header Content */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                    gap: 2,
                }}
            >
                <Box>
                    <Typography
                        variant="h3"
                        component="h1"
                        sx={{
                            fontWeight: 700,
                            color: "#1a1a1a",
                            mb: 1,
                            background: "linear-gradient(135deg, #96D232 0%, #7AB829 100%)",
                            backgroundClip: "text",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}
                    >
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography
                            variant="h6"
                            sx={{
                                color: "#666",
                                fontWeight: 400,
                                maxWidth: 600,
                            }}
                        >
                            {subtitle}
                        </Typography>
                    )}
                </Box>

                {actions && <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>{actions}</Box>}
            </Box>
        </Box>
    )
}

export default EnhancedHeader
